import { useState, useEffect } from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore } from '../tables/views/tbview-store'

export default function useLog(data) {
  const [logsData, setLogsData] = useState([])

  const [tbs, setTbs] = useState()
  const [loading, setLoading] = useState(false)
  const [order, setOrder] = useState('desc')
  const { ditto, tbId } = useTbViewStore((state) =>
    pick(state, ['ditto', 'tbId'])
  )

  const getLogsData = async () => {
    setLoading(true)
    const filters = {
      logicType: 'and',
      queries: [
        {
          slug: 'tbIdInfo',
          value: `${tbId}`,
          queryType: ['equal'],
        },
        {
          slug: 'objectIdInfo',
          value: data.objectId,
          queryType: ['equal'],
        },
        {
          slug: 'isBigTableLog',
          value: true,
          queryType: ['notEqual'],
        },
      ],
    }
    const sorts = [{ slug: 'createdAt', order }]
    const logsModel = ditto.logsModel()
    if (!logsModel || !logsModel.fetchTbData) {
      setLoading(false)
      return
    }

    const datas = await logsModel.fetchTbData({
      filters,
      sorts,
      pageSize: 1000,
    })
    setLogsData(datas)

    setLoading(false)
    setTbs(logsModel.tbs)
  }
  // const transFormKey = (d) => {
  //   const result = tbs[d.tbId].fields.filter((field) => {
  //     return field.slug === d.key
  //   })
  //   return result[0] ? result[0].title : ''
  // }

  useEffect(() => {
    if (Object.keys(data || {}).length !== 0) {
      getLogsData()
    } else {
      setLogsData([])
    }
  }, [data])

  useEffect(() => {
    getLogsData()
  }, [order])

  return {
    loading,
    logsData,
    tbs,
    getLogsData,
    setLoading,
    setOrder,
    order,
  }
}
